import React, { lazy } from 'react';
import CreateColumns from 'components/tables/assigned/columns';
import AsignedAssetsTable from 'components/tables/assigned/asignedTable';

//const AsignedAssetsTable = lazy(() => import('components/tables/assigned/asignedTable'));

import { useAppSelector } from 'reduxStore/hooks';

import config from 'config';
import { FaCube } from 'react-icons/fa';
export default function AssignedTable() {
    const xmlData = useAppSelector((state) => state.asignToPersonSlice.xmlData);
    const xmlDataHeaders = useAppSelector((state) => state.asignToPersonSlice.xmlDataHeaders);
    const xmlDataWidths = useAppSelector((state) => state.asignToPersonSlice.xmlDataWidths);
    const xmlDataSorts = useAppSelector((state) => state.asignToPersonSlice.xmlDataSorts);
    const tableWidth = useAppSelector((state) => state.asignToPersonSlice.tableWidth);
    const listTitle = useAppSelector((state) => state.asignToPersonSlice.listTitle);
    const totalAssets = useAppSelector((state) => state.asignToPersonSlice.totalAssets);
    const AssignedColumns = CreateColumns(xmlDataHeaders, xmlDataWidths, xmlDataSorts, tableWidth);
    return (
        <>
            <section className="VZ__table__header">
                {/* <span className="VZ__table__header__total">{totalAssets} </span>{' '} */}
                <h2>
                    {listTitle}<span className="VZ__table__header__total">({totalAssets})</span>
                </h2>
            </section>

            <AsignedAssetsTable
                xmlData={xmlData}
                //xmlData={[]}
                AssignedColumns={AssignedColumns}
                tableWith={tableWidth}
            />
        </>
    );
}
